import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import type React from 'react';
type FadeInContainerProps = {
  children: React.ReactNode;
};
const FadeInContainer = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1,
      transition: {
        type: "tween",
        duration: 0.7
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <motion.div className="h-full" initial={t1} animate={t2}>{children}</motion.div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default FadeInContainer;